import React from "react";
import ContentHeader from "../contentHeader";
import { Link } from "react-router-dom";
import Records from "../records";
import Pagination from "../pagination";
import SearchBox from "../searchBox";

export function CrudLayout({
  title,
  breadcrumbs,
  permisos,
  newLink,
  newLabel = "Nuevo",
  searchValue = "",
  onChangeSearch,
  filterData,
  onPageChange,
  totalCount,
  pageSize,
  currentPage,
  children,
}) {
  return (
    <>
      <ContentHeader title={title} breadcrumbs={breadcrumbs} />
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-body h-75">
                  <div id="datatable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        {permisos.canAdd && (
                          <div className="dt-buttons btn-group flex-wrap">
                            <Link to={newLink}>
                              <button
                                className="btn btn-secondary buttons-copy buttons-html5"
                                tabIndex={0}
                                aria-controls="datatable"
                                type="button"
                              >
                                <span>{newLabel}</span>
                              </button>
                            </Link>
                          </div>
                        )}
                      </div>
                      {filterData && <SearchBox value={searchValue} onChange={onChangeSearch} />}
                    </div>
                    {children}
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <Records itemsCount={totalCount} pageSize={pageSize} currentPage={currentPage} />
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination
                          onPageChange={(page) => onPageChange(page)}
                          itemsCount={totalCount}
                          pageSize={pageSize}
                          currentPage={currentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
